/* Infapower – AJAX "Add to order" + header cart refresh + mobile menu */
(function () {
  if (window.__ipReady) return;
  window.__ipReady = true;

  function money(cents) {
    var fmt = (window.ipMoneyFormat || '£{{amount}}');
    var v = (cents / 100).toFixed(2);
    var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return withCommas.split('.')[0];
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return withCommas;
    });
  }

  function toast(html) {
    var t = document.querySelector('.ip-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ip-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  function refreshCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ip-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('[data-ip-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        return cart;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ip-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    var label = btn.textContent;
    btn.classList.add('is-loading');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (item) {
        btn.classList.remove('is-loading'); btn.classList.add('is-added'); btn.textContent = 'Added ✓';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 1800);
        toast(item.quantity + ' × ' + item.product_title + ' added. <a href="/cart">View basket</a>');
        return refreshCart();
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        toast((err && (err.description || err.message)) || 'Sorry, that could not be added.');
      });
  });

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-ip-menu-open]');
    var close = e.target.closest('[data-ip-menu-close]');
    var m = document.querySelector('[data-ip-mnav]');
    if (!m) return;
    if (open) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (close) { m.classList.remove('is-open'); document.body.style.overflow = ''; }
  });
})();
